<template>
    <div class="app">
        <TopNav></TopNav>
        <div class="center">
            <!-- 案例头部模块 -->
            <div class="al-hd">
                <div class="title_content">
                    <div class="title">
                        <img src="../assets/tb.png" style="margin-right: .4rem;" alt="">
                        <h1>成功案例</h1>
                        <img src="../assets/tb 1.png" style="margin-left: .4rem;" alt="">
                    </div>
                    <p>全国布点，业务覆盖广，服务更专业</p>
                </div>
            </div>

            <!-- 案例主体模块 -->
            <div class="al-bd">
                <div class="content_row">
                    <div class="swiper mySwiper">
                        <div class="swiper-wrapper">
                            <div class="swiper-slide">
                                <img src="../assets/al1.jpg" alt="">
                                <p>西安市霖昌易购乐市场</p>
                            </div>
                            <div class="swiper-slide">
                                <img src="../assets/sc-pic1.png" alt="">
                                <p>佛山市金沙市场</p>
                            </div>
                            <div class="swiper-slide">
                                <img src="../assets/sc-pic2.png" alt="">
                                <p>佛山市嫩茶市场</p>
                            </div>
                            <div class="swiper-slide">
                                <img src="../assets/sc-pic3.png" alt="">
                                <p>佛山市大朗市场</p>
                            </div>

                        </div>
                        <div class="swiper-pagination"></div>
                    </div>
                </div>
            </div>
        </div>
        <BottomNav></BottomNav>
    </div>
</template>

<script>
import TopNav from '../components/TopNav.vue'
import BottomNav from '../components/BottomNav.vue'
import Swiper from 'swiper'; // 注意引入的是Swiper
import 'swiper/css/swiper.min.css' // 注意这里的引入
export default {
    components: { TopNav, BottomNav },
    data() {
        return {

        }
    },
    created() { },
    mounted() {
        var swiper = new Swiper(".mySwiper", {
            autoplay: true, //可选选项，自动滑动  initialSlide :0,
            observer: true,//修改swiper自己或子元素时，自动初始化swiper
            observeParents: true,//修改swiper的父元素时，自动初始化swiper
            slidesPerView: 3.5,
            spaceBetween: 30,
            autoplay: {
                delay: 6000,
                disableOnInteraction: false,
            },
        });
    },
    methods: {},
}
</script>

<style lang="less" scoped>
.app {
    width: 100vw;
    height: 100vh;
    background-size: cover;
    z-index: -1;
    overflow-x: hidden;
}

.center {
    width: 100%;
    min-height: calc(100vh - .8333rem - 5.9063rem);
    margin-top: .8333rem;
    overflow: hidden;
}

.content_row {
    width: 100%;
    height: 100%;
    padding: 0 4.25rem;
    box-sizing: border-box;
}

.title_content {
    display: flex;
    flex-direction: column;
    align-items: center;
}

.title_content .title {
    display: flex;
    align-items: center;
}

.title_content img {
    width: 1.1458rem;
    height: .2292rem;
}

.title_content h1 {
    font-size: .3958rem;
}

.title_content p {
    height: .3021rem;
    font-size: .2188rem;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #232A24;
    line-height: .3021rem;
    margin-top: .2917rem;
}

.al-hd {
    width: 100%;
    height: 2rem;
    margin-top: .73rem;
}

.al-hd h1 {
    height: .5rem;
    font-size: .3958rem;
    font-family: PingFangSC-Semibold, PingFang SC;
    font-weight: 600;
    color: #232A24;
    line-height: .5rem;
}


.al-hd .al-hd-box1 p {
    height: .3021rem;
    font-size: .2188rem;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #232A24;
    line-height: .3021rem;
    margin-top: .2917rem;
}

.al-bd {
    display: flex;
    justify-content: space-around;
    height: 5rem;
    margin-bottom: .1042rem;
    padding-top: .25rem;
}

.al-bd .swiper {
    position: relative;
    overflow: hidden;
    width: 100%;
    height: 100%;
    height: 4.2083rem;
    box-shadow: 0px 0px .2604rem .0104rem rgba(35, 42, 36, 0.1);
}

.al-bd .swiper-slide {
    text-align: center;
    font-size: 18px;
    background: #fff;
    display: -webkit-box;
    display: -ms-flexbox;
    display: -webkit-flex;
    display: flex;
    -webkit-box-pack: center;
    -ms-flex-pack: center;
    -webkit-justify-content: center;
    justify-content: center;
    -webkit-box-align: center;
    -ms-flex-align: center;
    -webkit-align-items: center;
    align-items: center;
}

.al-bd .swiper-slide img {
    display: block;
    width: 100%;
    height: 100%;
    object-fit: cover;
}

.al-bd .swiper-slide p {
    position: absolute;
    left: 0;
    bottom: 0;
    width: 100%;
    height: .5208rem;
    line-height: .5208rem;
    text-align: center;
    color: #fff;
    font-size: .25rem;
    background-color: rgba(0, 0, 0, 0.4);
}
</style>